var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap01 = function SvgMap01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.353 20.962-6.706-2.1-4.81 1.665q-.495.17-.916-.098-.42-.27-.421-.737L2.484 5.58q0-.297.177-.532a1 1 0 0 1 .498-.341L8.63 3.04l6.705 2.1 4.81-1.665q.495-.17.916.083.422.255.422.713l.016 14.19a.8.8 0 0 1-.193.536q-.194.231-.525.336zm-.838-1.835L14.498 6.43l-5.03-1.574.017 12.698zm1.676 0 3.633-1.077-.017-12.847-3.632 1.227zM4.176 18.8l3.633-1.246-.017-12.698L4.16 5.953z"
  })));
};
export default SvgMap01;